// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  guildCandidateId: __t.u64().primaryKey().name("guild_candidate_id"),
  guildElectionId: __t.u64().name("guild_election_id"),
  identity: __t.identity(),
  pitch: __t.string(),
  at: __t.timestamp(),
});
